import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { SellerAgentBadge } from '@/components/kypa/SellerAgentBadge';

const API = process.env.REACT_APP_BACKEND_URL;

export function SellerDomainPanel({ profile, onUpdate }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  if (profile.agent_role !== 'seller') return null;
  const snippet = JSON.stringify({ merchant: profile.merchant_domain, agents: [{ wallet: profile.wallet_address, role: 'seller agent', kypaId: profile.kypa_id }] }, null, 2);
  const recheck = async () => {
    setBusy(true); setError(null);
    const r = await fetch(`${API}/api/kypa/profile/${encodeURIComponent(profile.kypa_id)}/check-domain`, { method: 'POST' });
    const d = await r.json();
    if (r.ok) onUpdate(d); else setError(d.detail || 'Check failed');
    setBusy(false);
  };
  return (
    <section className="px-6 pb-8" data-testid="kypa-seller-domain-panel">
      <div className="container mx-auto max-w-6xl rounded-2xl border border-sky-500/25 bg-sky-500/[0.04] p-6">
        <h2 className="text-base md:text-lg font-semibold mb-2">Retailer domain</h2>
        <SellerAgentBadge agent={profile} testid="kypa-profile-seller-badge" />
        <p className="text-sm text-gray-300" data-testid="kypa-seller-domain-reason">{profile.domain_reason || 'Not checked yet.'}</p>
        {profile.domain_checked_at && <p className="text-xs text-gray-500 mt-1" data-testid="kypa-seller-domain-checked-at">Last checked {new Date(profile.domain_checked_at).toUTCString()}</p>}
        <p className="text-sm text-gray-400 mt-4 max-w-3xl" data-testid="kypa-seller-domain-howto">
          {profile.domain_status === 'confirmed' ? 'The retailer lists this agent in its own claims file at ' : 'To confirm, the retailer adds this agent to its own claims file at '}
          <span className="font-mono text-gray-200 break-all">https://{profile.merchant_domain}/.well-known/claim-records.json</span>.
          {profile.domain_status === 'confirmed' ? ' If the retailer removes it, the next check shows "Domain not yet confirmed."' : ' Only the retailer can publish it, so only the retailer can confirm the agent.'}
        </p>
        <pre className="mt-3 rounded-xl bg-black/50 border border-white/10 p-4 text-xs text-gray-300 overflow-x-auto" data-testid="kypa-seller-domain-snippet">{snippet}</pre>
        <div className="flex flex-wrap items-center gap-3 mt-4">
          <button type="button" onClick={recheck} disabled={busy} className="inline-flex items-center gap-2 rounded-full border border-sky-400/50 px-4 py-2 text-sm text-sky-200 hover:bg-sky-500/10 transition-colors disabled:opacity-50" data-testid="kypa-seller-domain-recheck-btn">
            <RefreshCw className={`w-4 h-4 ${busy ? 'animate-spin' : ''}`} /> Check domain now
          </button>
          {error && <span className="text-xs text-red-300" data-testid="kypa-seller-domain-error">{error}</span>}
        </div>
        <p className="text-[11px] text-gray-500 mt-4">A confirmed domain shows only that the retailer's own file lists this wallet. It is not an endorsement, a rating, or a guarantee by Kojiru.</p>
      </div>
    </section>
  );
}
